module.exports = __webpack_public_path__ + "img/Reg-2-WorldExperts.dd874744.svg";